import React, { useEffect, useState } from 'react'
import PublicNavbar from '../../components/PublicNavbar/PublicNavbar'
import { Link, useParams } from 'react-router-dom'
import client from '../../api/client'
import showToast from '../../components/CustomToast/toastHelper'

const VerifyEmail = () => {
    const { token } = useParams()
    const [message, setMessage] = useState<string>('')

    useEffect(() => {
        const fetchData = async () => {
            await emailVerfy()
        }
        fetchData()
    }, [])
    const emailVerfy = async () => {
        try {
            const apiUrl = '/subsidiary/dashboard/verify/business/email';
            const response = await client.get(`${apiUrl}?token=${token}`);
            const message = response?.data?.message;
            setMessage(message)

        } catch (err: any) {

            const message = err?.response?.data?.message;
            console.error('error getting data', err);
            setMessage(message)
        }
    };
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <PublicNavbar />
            <div className="flex flex-col items-center mt-16 p-8 bg-white rounded shadow-lg">
                <h1 className="text-xl font-bold mb-4">Email Verification Completed</h1>
                <p className="text-gray-700 mb-6">
                    {message}
                </p>
                <Link to="/login"><button
                    className="px-4 py-2 bg-custom-button-green text-black rounded hover:bg-green-900 hover:text-white"
                >
                    Go to Login
                </button>
                </Link>
            </div>
        </div>
    )
}

export default VerifyEmail
